import { useMutation, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentClient as advisorUpdateCurrentClient } from '../../../AdviserArea/AdviserAreaActions';
import { updateCurrentClient as clientUpdateCurrentClient } from '../../../ConsumerArea/ConsumerAreaActions';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { isConsumerArea as selectIsConsumerArea } from '../../../CommonSelectors/CommonAreaSelector';
import { useClientId } from '../../../_hooks/useClientId';
import { UpdatePersonalInfoBody } from './useUpdatePersonalInfoMutation';
import { EstatePlanningDTO } from './useEstatePlanningPersonalInfoQuery';

export const UPDATE_ESTATE_PLANNING_PERSONAL_INFO_ENDPOINT =
  '/Consumer/EstatePlanningPersonalInfoUpdate';

export const UPDATE_ESTATE_PLANNING_PERSONAL_INFO_MK = 'updateEstatePlanningPersonalInfo';

export interface UpdateEstatePlanningPersonalInfoBody {
  PersonalInfo: UpdatePersonalInfoBody;
  EstatePlanning: EstatePlanningDTO;
}

interface UpdateEstatePlanningPersonalInfoBodyParams {
  body: {
    PersonalInfo: UpdatePersonalInfoBody;
    EstatePlanning: EstatePlanningDTO;
  };
}

const updateEstatePlanningPersonalInfo = (clientId: number) => ({
  body,
}: UpdateEstatePlanningPersonalInfoBodyParams) => {
  return authFetch(urlWithParams(UPDATE_ESTATE_PLANNING_PERSONAL_INFO_ENDPOINT, { clientId }), {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

export const useEstatePlanningPersonalInfoMutation = () => {
  const clientId = useClientId();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const isConsumerArea = useSelector(selectIsConsumerArea);

  return useMutation(updateEstatePlanningPersonalInfo(clientId), {
    mutationKey: UPDATE_ESTATE_PLANNING_PERSONAL_INFO_MK,

    onSuccess(data) {
      queryClient.invalidateQueries(queryKeys.estatePlanningPersonalInfo(clientId));

      const updateClient = {
        Dob: data.PersonalInfo.Principal.Dob,
        IsCanadian: data.PersonalInfo.IsCanadian,
        ...(data.PersonalInfo.Partner
          ? {
              PartnerDob: data.PersonalInfo.Partner.Dob,
              PartnerName: `${data.PersonalInfo.Partner.FirstName} ${data.PersonalInfo.Partner.LastName}`,
            }
          : { PartnerName: null }),
      };

      if (isConsumerArea) {
        dispatch(clientUpdateCurrentClient(updateClient));
      } else {
        dispatch(advisorUpdateCurrentClient(updateClient));
      }
    },
  });
};
